import React from 'react';
import { listContainerStyle, sectionHeaderStyle } from './styles';

interface TeleporterDetailsProps {
  teleporters: any[];
}

export const TeleporterDetails: React.FC<TeleporterDetailsProps> = ({ teleporters }) => {
  return (
    <>
      <div style={sectionHeaderStyle}>Teleporters ({teleporters.length})</div>
      <div style={listContainerStyle}>
        {teleporters.length === 0 ? (
          <div style={{ fontSize: '11px', color: '#666', textAlign: 'center' }}>No teleporters</div>
        ) : (
          teleporters.map((t, i) => (
            <div key={t.id || i} style={{
              fontSize: '10px',
              color: '#aaa',
              padding: '6px 0',
              borderBottom: '1px solid rgba(255,255,255,0.05)'
            }}>
              <div style={{ color: '#3498db', fontWeight: 'bold', marginBottom: '2px' }}>{t.id || `tele_${i}`}</div>
              <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <span>Pos: ({t.x}, {t.y})</span>
                <span style={{ color: '#2ecc71' }}>Target: {t.targetMapId}</span>
              </div>
              <div style={{ fontSize: '9px', color: '#555' }}>Spawn ID: {t.targetSpawnId}</div>
            </div>
          ))
        )}
      </div>
    </>
  );
};
